/**
 * 地图相关配置常量
 */

// API 基础路径
export const BASE_URL = "https://ait7.cn/f/";
export const BASE_URL_MECN = BASE_URL + "mecn/";

// 地图瓦片 URL 列表
export const MAP_TILE_URLS = [
  "https://webst01.is.autonavi.com/appmaptile?style=6&x={x}&y={y}&z={z}",
  "https://{s}.basemaps.cartocdn.com/dark_nolabels/{z}/{x}/{y}.png",
  "https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png",
  "http://{s}.tile.osm.org/{z}/{x}/{y}.png"
];

// 地图初始化配置
export const MAP_OPTIONS = {
  center: [43.9008184833268, 125.25321722030641], // 中心位置：中国东北
  zoom: 6,
  attributionControl: true,
  zoomControl: true,
  maxZoom: 12,
  minZoom: 4,
  preferCanvas: true // Canvas 渲染矢量图层，确保截图兼容
};

// 机场面要素样式
export const BOUNDARY_STYLE = {
  color: "#ff6601",
  weight: 3,
  opacity: 1,
  fillColor: "#d4944a",
  fillOpacity: 0.55
};

// 省界样式
export const PROVINCE_BORDER_STYLE = {
  color: "#4ed7ff",
  weight: 2,
  opacity: 0.9,
  fillColor: 'transparent',
  fillOpacity: 0
};

// 市界样式
export const CITY_BORDER_STYLE = {
  color: "#4ed7ff",
  weight: 1,
  opacity: 0.5,
  fillColor: 'transparent',
  fillOpacity: 0
};

// 云图 imageOverlay 地理范围
export const CLOUD_IMG_BOUNDS = [
  [-1.15, 58.83],   // 西南角 [南纬, 西经]
  [60.55, 151.15],  // 东北角 [北纬, 东经]
];

// 市界显示缩放阈值
export const CITY_ZOOM_THRESHOLD = 7;
